import axios, { AxiosResponse } from 'axios';

export default function searchInstrumentBySerialAsync(apiUrl: string) {
  return function api<TResponse>(
    serialNumber: string | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/instruments/serial/search/${serialNumber}`,
          method: 'GET',
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
